import type { ButtonProps } from '@eleo-rh/core-ui'
import { Flex } from 'antd'
import type { ReactNode } from 'react'
import Button from './CoreUIButton'
import SearchInput from './SearchInput'
import SectionTitle from './SectionTitle'

export interface SectionHeaderProps {
  title: ReactNode
  buttonLabel?: ReactNode
  buttonProps?: ButtonProps
  withSearch?: boolean
  onSearchChange?: (value: string) => void
  showSecondButton?: boolean
  secondButtonLabel?: ReactNode
  secondButtonProps?: ButtonProps
  secondButton?: ReactNode
}
export default function SectionHeader({
  title,
  buttonLabel,
  buttonProps,
  withSearch = false,
  showSecondButton = false,
  secondButtonLabel,
  secondButtonProps,
  secondButton,
  onSearchChange,
}: SectionHeaderProps) {
  return (
    <div className="flex flex-col gap-2 mb-4">
      <Flex justify="space-between" align="center">
        <SectionTitle size="3xl" level={1}>
          {title}
        </SectionTitle>

        <Flex gap={8}>
          {(showSecondButton || secondButton || secondButtonLabel) &&
            (secondButton ? (
              secondButton
            ) : secondButtonLabel ? (
              <Button variant="primary" {...secondButtonProps}>
                {secondButtonLabel}
              </Button>
            ) : null)}

          {buttonLabel ? (
            <Button variant="primary" {...buttonProps}>
              {buttonLabel}
            </Button>
          ) : null}
        </Flex>
      </Flex>

      {withSearch && (
        <div className="mt-3">
          <SearchInput size="medium" onChange={value => onSearchChange?.(value)} />
        </div>
      )}
    </div>
  )
}
